import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import homeBanner from '../../images/home-environment.jpg';
import businessBanner from '../../images/business-environment.jpg';

const ServiceType = () => (
  <div className="ServiceType">
    <Container>
      <Row>
        <Col md={{ span: 8, offset: 2 }}>
          <Row>
            <Col md={6}>
              <Image fluid src={homeBanner} className="rounded" />
              <h2 className="SectionHeading">Services for home</h2>
              <p className="mb-0">Services for homes is the core of us. Our interest has always been providing best efforts for homes.</p>
            </Col>
            <Col md={6}>
              <Image fluid src={businessBanner} className="rounded" />
              <h2 className="SectionHeading">Services for business</h2>
              <p className="mb-0">Geeks Sydney can be very reliable with business. That is also among the strong forte of our geeks.</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
);

export default ServiceType;